import { render, staticRenderFns } from "./c-control-panel-manage-pharmacists.vue?vue&type=template&id=bb44fe16&scoped=true&"
import script from "./c-control-panel-manage-pharmacists.vue?vue&type=script&lang=js&"
export * from "./c-control-panel-manage-pharmacists.vue?vue&type=script&lang=js&"
import style0 from "./c-control-panel-manage-pharmacists.vue?vue&type=style&index=0&id=bb44fe16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb44fe16",
  null
  
)

export default component.exports